import React from "react";
import Select from "react-select";

export default function MultiSelectComp(props) {
  return <Select multi {...props} />;
}
